"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadRequests = void 0;
const Paths_1 = require("../../Paths");
const Utils_1 = require("../../Utils");
const SwitchRequests_1 = require("./SwitchRequests");
const ProfileRequestUtils_1 = require("./utils/ProfileRequestUtils");
class LoadRequests {
    constructor(session, profileId) {
        this.session = session;
        this.profileId = profileId;
    }
    create(name, multiway, switchUUIDS) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiLoad = {
                kind: null,
                multi_way: multiway,
                name,
                switch_ids: switchUUIDS,
                profile_id: this.profileId,
            };
            const loadRequest = {
                method: Paths_1.Methods.POST,
                body: apiLoad,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, loadRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, loadRequest, Paths_1.Constants.LOAD);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    get(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const loadRequest = {
                method: Paths_1.Methods.GET,
                body: {
                    uuid,
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, loadRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, loadRequest, Paths_1.Constants.LOAD);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    remove(uuid, removeSwitches) {
        return __awaiter(this, void 0, void 0, function* () {
            if (removeSwitches) {
                const ourLoad = yield this.get(uuid);
                const removePromises = [];
                for (const switchUUID of ourLoad.switches) {
                    const switchRequests = new SwitchRequests_1.SwitchRequests(this.session, this.profileId);
                    removePromises.push(switchRequests.remove(switchUUID));
                }
                yield Promise.all(removePromises);
            }
            const loadRequest = {
                method: Paths_1.Methods.DELETE,
                body: {
                    uuid,
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, loadRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, loadRequest, Paths_1.Constants.LOAD);
            return (0, Utils_1.wrapFetch)(request, endpoint);
        });
    }
    update(uuid, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const switchRequest = {
                method: Paths_1.Methods.PUT,
                body: Object.assign(Object.assign({}, changes), { uuid }),
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, switchRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, switchRequest, Paths_1.Constants.LOAD);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    genericLoadRequest(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = (0, ProfileRequestUtils_1.getEndpoint)(this.session, options, this.profileId, Paths_1.Constants.LOAD);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
}
exports.LoadRequests = LoadRequests;
//# sourceMappingURL=LoadRequests.js.map